<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card no-header>
          <b-alert
            class="alert"
            :show="dismissCountDown"
            dismissible
            fade
            :variant="alertVariant"
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged">
            <p>{{ alertMsj }}</p>
          </b-alert>             

          <b-form>
            <b-form-group
              label="Fecha Crédito/Débito"
              label-for="fechaCreditoDebito"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaCreditoDebito" 
                v-model="fechaCreditoDebito" 
                type="date">
              </b-form-input>
            </b-form-group>
          </b-form>
          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Grabar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="goBack">Cancelar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import moment from 'moment';

export default {
  name: 'ABM',
  components: {
    appMensaje: Mensaje
  },
  mixins: [
    msjModal
  ],
  props: {
    bancoMovimientoId: {
      type: Number,
      default: 0
    },
    fechaCreditoDebitoActual: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      fechaCreditoDebito: new Date(),

      labelCols: 3,
      alertCountDown: 10, 
      dismissCountDown: 0,
      alertVariant: 'danger',
      alertMsj: ''
    }
  },
  created() {
    this.fechaCreditoDebito = moment.utc(this.fechaCreditoDebitoActual).format('YYYY-MM-DD');
    // console.log(this.fechaCreditoDebito);
  },  
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.alertCountDown;
    },
    save () {
      let save = Boolean(true);

      if (save) {
        let params = {
          bancoMovimientoId: this.bancoMovimientoId,
          fechaCreditoDebito: moment(this.fechaCreditoDebito).format('YYYY-MM-DD')
        }

        let msj = 'El movimiento se concilió con éxito.';
        if (this.bancoMovimientoId == 0) {
          msj = 'Los movimientos seleccionados se conciliaron con éxito.';
        }

        this.showSpinner();
        this.$store.dispatch('bancosmovimientos/conciliar', params)
          .then(() => this.showModalMsj(msj, this.movimientoConciliado, this.movimientoConciliado, 'light'))
          .catch( error => {
            this.alertMsj = error;
            this.alertVariant = "danger";
            this.alertCountDown = 15;
            this.showAlert();              
          })
          .finally(() => this.hideSpinner());
      }
    },
    movimientoConciliado() {
      this.$emit('movimientoConciliado');
    },
    goBack() {
      this.$emit('close');
    },
  },
}
</script>

<style>
</style>
